﻿// Parcel Entry Point - URL Asset Resolution
import $ from 'jquery';
import Hammer from 'hammerjs';

// Expose globals for legacy script support
window.jQuery = window.$ = $;
window.Hammer = Hammer;

// --- ASSET RESOLUTION (DOM-REGISTRY Pattern for Parcel) ---
// ------------------------

// Import Styles
import '../assets/css/main.css';
import '../assets/css/circuit-bg.css';

// Core Scripts
import '../assets/js/src/circuit-bg.js';
import '../assets/js/src/functions.js';

// Canvas Animations
import '../assets/js/src/network-animation.js';
import '../assets/js/src/constellation-works.js';
import '../assets/js/src/contact-stars.js';

// Final Scripts
import '../assets/js/src/contact-mesh.js';
import '../assets/js/src/about-details.js';
import '../assets/js/src/global-hologram.js';

console.log('Parcel: Full Bundle with URL Assets Ready');

// PWA: Service Worker Registration
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(new URL('./sw.js', import.meta.url), { type: 'module' })
            .then(reg => console.log('PWA: Service Worker Registered', reg))
            .catch(err => console.error('PWA: Service Worker Registration Failed', err));
    });
}
